export default __webpack_public_path__ + "static/media/logo.c50300d4.png";